const getMultiSelect = (tokens) => ({
    button: {
        width: '180px',
        minWidth: '120px',
        height: '48px',
        bg: tokens.Layer02,
        fontSize: tokens.TextBodyReg3FontSize,
        borderColor: tokens.BorderLight500,
        borderRadius: tokens.BorderRadius02,
        borderWidth: tokens.BorderWidth01,
        transition: 'all 0.2s',
        px: 4,
        textAlign: 'left',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'flex',
        justifyContent: 'space-between',
        svg: {
            float: 'right',
            marginTop: tokens.Spacing01,
            marginLeft: tokens.Spacing01,
        },
        _hover: { bg: tokens.Layer01 },
        _expanded: { boxShadow: 'outline' },
        _focus: { boxShadow: 'outline' },
        span: {
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
});
const menuStyles = (tokens) => ({
    variants: {
        select: {
            button: {
                width: '100%',
                minWidth: '120px',
                height: '48px',
                textAlign: 'left',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                display: 'flex',
                justifyContent: 'space-between',
                span: {
                    flex: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
            },
            list: {
                midWidth: '100%',
                borderRadius: tokens.BorderRadius02,
                boxShadow: '0px 0px 6px 0px rgba(26, 26, 26, 0.40)',
                minWidth: '288px',
                maxHeight: '400px',
                overflowY: 'auto',
            },
        },
        menu: {
            bgColor: 'white',
            list: {
                midWidth: '240px',
                button: {
                    _hover: {
                        bgColor: tokens.Layer03,
                    },
                },
            },
        },
        small: {
            list: {
                minW: '80px',
                borderWidth: tokens.BorderWidth01,
                borderRadius: tokens.BorderRadius02,
                borderColor: tokens.BorderMedium600,
                boxShadow: '0px 2px 4px 0 rgba(26, 26, 26, 0.4)',
                mt: '-15px',
                button: {
                    _hover: {
                        bgColor: tokens.Layer03,
                    },
                },
            },
        },
        'multi-select': {
            ...getMultiSelect(tokens),
            list: {
                minWidth: '240px',
            },
        },
        'multi-select-long': {
            ...getMultiSelect(tokens),
            list: {
                minWidth: '240px',
            },
            button: {
                ...getMultiSelect(tokens).button,
                minWidth: '240px',
            },
        },
        'multi-select-thin': {
            ...getMultiSelect(tokens),
            list: {
                minWidth: '160px',
            },
            button: {
                ...getMultiSelect(tokens).button,
                minWidth: '120px',
            },
        },
    },
});
export default menuStyles;
